import { render, staticRenderFns } from "./fertiliser_spreading.vue?vue&type=template&id=b018ca10"
import script from "./fertiliser_spreading.vue?vue&type=script&lang=js"
export * from "./fertiliser_spreading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports